import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-overlay-spinner",
	templateUrl: "./overlay-spinner.component.html",
	styleUrls: ["./overlay-spinner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class OverlaySpinnerComponent {
	@HostBinding("class.obg-m-overlay-spinner") class = true;
	@HostBinding("class.obg-m-overlay-spinner-message") cssMessageClass = false;

	@Input() diameter = 40;
	@HostBinding("class.is-dialog")
	@Input()
	dialog = false;
	@Input() set message(value: string) {
		this._message = value;
		this.cssMessageClass = !!value;
	}

	get message(): string {
		return this._message;
	}

	private _message = "";
}
